import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-title">NANTES DOULON BOTTIERE FUTSAL</div>
            <div className="footer-columns">
                {/* Colonne 1 : Coordonnées */}
                <div className="footer-column">
                    <h3>Coordonnées</h3>
                    <p>
                        <i className="fas fa-envelope"></i> nantesdoulonfutsal@gmail.com
                    </p>
                    <p>
                        <i className="fas fa-map-marker-alt"></i> 17 Route du Chêne Vert,
                        Thouaré-sur-Loire, 44470
                    </p>
                </div>
                {/* Colonne 2 : Réseaux sociaux */}
                <div className="footer-column">
                    <h3>Suivez-nous</h3>
                    <div className="social-icons">
                        <a href="https://www.facebook.com/NantesDoulonBottiereFutsal?locale=fr_FR" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-facebook-f"></i>
                        </a>
                        <a href="https://www.instagram.com/nantes_doulon_bottiere_futsal/?hl=fr" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-instagram"></i>
                        </a>
                    </div>
                </div>
                {/* Colonne 3 : Newsletter */}
                <div className="footer-column">
                    <h3>Newsletter</h3>
                    <p>Inscrivez-vous pour recevoir nos dernières actualités :</p>
                    <form className="newsletter-form">
                        <input type="email" placeholder="Votre email" />
                        <button type="submit">S'inscrire</button>
                    </form>
                </div>
            </div>
            <div className="footer-copyright">
                © {new Date().getFullYear()} Nantes Doulon Bottière Futsal. Tous droits réservés.
            </div>
        </footer>

    );
}

export default Footer;
